import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { ConfigService } from '../services/config.service';

@Directive({
  selector: '[appShowResource]'
})
export class ShowResourceDirective {
  @Input() set appShowResource(resourceName: string) {
    if (this.configService.hasResource(resourceName)) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainerRef.clear();
    }
  }

  constructor(
    private readonly configService: ConfigService,
    private readonly viewContainerRef: ViewContainerRef,
    private readonly templateRef: TemplateRef<any>
  ) { }
}
